import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    display: 'none',
    paddingTop: spacing[12],
    paddingBottom: spacing[4],
    marginTop: 'auto',
    alignItems: 'center',
    width: '100%',
    minWidthMobileLg: {
      display: 'flex',
    },
  },
};

export default styles;
